import { LOCALES, KEYS } from '../constants';

const ruRUTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_RUSSIAN_RU] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Роль партнера",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Интегратор",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Поставщик",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Уровень партнера",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Специализация партнера",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Сервис Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Наименование партнера",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Местоположение",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Страна",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Ключевое слово в наименовании партнера",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Ключевые слова в наименовании партнера",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Сортировка",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Специализации",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Специализации партнера",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Уровень поставщика и услуги Cisco Powered",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"поставщик уровня gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"поставщик уровня premier",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"поставщик уровня select",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Получайте рекомендации",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Запросить квоту",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Открыть",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Развернуть",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Свернуть",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Выберите страну/регион",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Выберите роль",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Выберите специализации",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Выберите услуги Cisco Powered",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Выберите опыт",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Выберите уровни",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Страна/регион партнера",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Уровни интеграторов",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Уровни поставщиков",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Специализации интеграторов",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Услуги Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Наименования партнеров",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Назад",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Все результаты",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Все",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Saved (Сохранен)",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Мои партнеры",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Добавить",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Удалить",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Добавить к сравнению ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Необходимо выбрать не менее одного варианта",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Сравнить выбранные позиции ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Удалить из сравнения",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Сравнить",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Уровень партнера",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Выполняется обработка",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"результат",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"Результаты",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Результаты отсутствуют",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"результат в",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"результат. в",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Нет результатов в",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Предыдущая",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Пред.",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Далее",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Сохранить",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Профессиональные знания",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Обзор",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"это Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Интеграторы разрабатывают комплексные решения для наших заказчиков. Как правило, они перепродают продукты, но решают бизнес-проблемы заказчиков, используя накопленный опыт.",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Поставщики— это эксперты по управляемым и облачным решениям. Заказчики хотят получать максимально гибкие решения, поэтому роль поставщиков на рынке становится все более значимой.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Предыдущие поисковые запросы",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Предыдущий поисковый запрос",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Роли ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Технология",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Отрасли",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Интеграторы",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Поставщики",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Другое",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Другие",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Сохраненные профили других партнеров отсутствуют",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Сохраненные профили интеграторов отсутствуют",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Сохраненные профили поставщиков отсутствуют",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"фильтрация по требованию",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"поиск по нескольким критериям",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"поиск по местоположению",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Все регионы: 1 партнер",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Все регионы:",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"партн.",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Нет партнеров, работающих",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"1 партнер в регионе",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"партн. в регионе",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Нет партнеров в регионе",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Изменить местоположение",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Фильтрация по требованию",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Поиск",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"по наименованию, уровню и опыту",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"выбраны",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Совпадений не найдено",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"По возрастанию рейтинга",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"По убыванию рейтинга",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"По алфавиту (А–Я)",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"По алфавиту (Я–А)",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Войдите в систему",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Для выполнения этого действия необходимо войти в систему",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Ошибка восстановления результатов поискового запроса",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Вход",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Профиль партнера успешно сохранен",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Не удалось сохранить профиль партнера",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Профиль партнера успешно удален",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Не удалось удалить профиль партнера",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Введите ключевое слово для поиска по наименованию, уровню или опыту",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Разработчики— это эксперты, которые создают персонализированные программные и аппаратные продукты на основе технологий Cisco, предлагая заказчикам уникальные решения для объединения различных систем в целях эффективности.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Консультанты— это специалисты с глубокими знаниями о той или иной отрасли, которые помогают компаниям находить решения сложных бизнес-задач.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Партнер, соответствующий требованиям об этносоциальном разнообразии",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"В алфавитном порядке",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"По уровню опыта",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Разработчик",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Консультант",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Фильтры",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Фильтр",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Профессиональная поддержка от партнеров",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Отклонить",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Специализация",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Профессиональные знания",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Описание отсутствует.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Сведения",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Очистить сравнение",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Сравнение партнеров",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Роль",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Технологическая направленность",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Описание",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Выбор языка",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Выйти",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Инклюзивный партнер",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "О Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Свяжитесь с нами",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Карьера",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Познакомьтесь с нашими партнерами",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Отзыв",
    [KEYS.L18N_KEY_LABEL_HELP]: "Помощь",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Положения и условия",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Заявление о конфиденциальности",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Файлы cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Товарные знаки",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Прозрачность цепочки поставок",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Карта сайта",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "О Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Свяжитесь с нами",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Карьера",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Познакомьтесь с нашими партнерами",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Отзыв",
    [KEYS.L18N_KEY_LABEL_HELP]: "Помощь",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Положения и условия",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Заявление о конфиденциальности",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Файлы cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Товарные знаки",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Прозрачность цепочки поставок",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Карта сайта",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Как купить",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Партнеры",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Продукты и услуги",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Решения",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Поддержка",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Узнать",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Изучить Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Меню",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Закрыть",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Подробнее",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Меньше видеть",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "У вас нет учетной записи?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "зарегистрироваться"
  }
});

export default ruRUTranslations;
